<div class="table-responsive table-scroll" ng-if="data.orders.data.length > 0">
    <div class="navbar fixed-panel-footer" ng-if="selectedItem.length">
        <div class="nav navbar-nav navbar-left">
            <a href="#" ng-click="selectAll(true)" class="btn mr-2 btn-outline">Select All</a>
            <a href="#" ng-click="selectAll(false)" class="btn btn-outline">Unselect</a>
        </div>
        <div class="nav navbar-nav navbar-center">
        </div>
        <div class="nav navbar-nav navbar-right">
            <a href="#"
                data-toggle="modal" 
                data-target="#deleteOrdersModal"
                class="hod-btn btn btn-danger btn-rounded mr-3">
                Delete
            </a>
            <a href="#"
                ng-click="printOrder(selectedItem)"
                class="hod-button blue">
                Print {{ selectedItem.length > 1 ? 'Orders' : 'Order'  }}
            </a>
        </div>
    </div>
    <!-- <a href="#" 
        ng-click="addRoute()"
        class="btn btn-success btn-rounded btn-sm ml10 mt10" 
        ng-if="selectedItem.length > 0">
        <i class="fa fa-plus"></i> Add Routing
    </a>
               
    <a href="#" 
        ng-click="addRoute()"
        class="btn btn-success btn-rounded btn-sm ml10 mt10" 
        ng-if="selectedItem.length == 0">
        <i class="fa fa-plus"></i> Add Routing All Pending Orders
    </a> -->
    <!-- <dir-pagination-controls 
        boundary-links="true" 
        on-page-change="getPage(newPageNumber)" 
        template-url="dirPagination.tpl.html"
        class="pagination-lg pagination pull-right pr10">
        Total Record {{data.orders.total }}
    </dir-pagination-controls> -->

    <table class="table table-hover tc-checkbox-1 fs13">
        <thead>
            <tr class="bg-light">
                <th class="text-center w75">
                    <!-- <label class="option block mn ml4">
                        <input type="checkbox" 
                            name="deleted[]" ng-model="master" ng-click="toggleSelectionCustomer($event)" id="checkboxAll" >
                        <span class="checkbox mn"></span>
                    </label> -->
                </th>
                <th>Partner</th>
                <th>Customer</th>
                <th>Order Id</th>
                <th>
                    Created
                    <a ng-click="sort('created_at','asc')" ng-if="filterData.sort == 'desc' || !filterData.field">
                        <i class="fa fa-sort-alpha-asc"></i>
                    </a>
                    <a ng-click="sort('created_at','desc')" ng-if="filterData.sort == 'asc'">
                        <i class="fa fa-sort-alpha-desc"></i>
                    </a>
                </th>
                <th>
                    Delivery
                    <a ng-click="sort('scheduled_time','asc')" ng-if="filterData.sort == 'desc' || !filterData.field">
                        <i class="fa fa-sort-alpha-asc"></i>
                    </a>
                    <a ng-click="sort('scheduled_time','desc')" ng-if="filterData.sort == 'asc'">
                        <i class="fa fa-sort-alpha-desc"></i>
                    </a>
                </th>
                <th>
                    Completed
                    <a ng-click="sort('completed_at','asc')" ng-if="filterData.sort == 'desc' || !filterData.field">
                        <i class="fa fa-sort-alpha-asc"></i>
                    </a>
                    <a ng-click="sort('completed_at','desc')" ng-if="filterData.sort == 'asc'">
                        <i class="fa fa-sort-alpha-desc"></i>
                    </a>
                </th>
                <th>Piece</th>
                <th>Details</th>
                <th>Driver</th>
                <th>
                    Status
                    <!-- <a ng-click="sort('status','desc')" ng-if="filterData.sort == 'asc' || !filterData.field">
                        <i class="fa fa-sort-alpha-desc"></i>
                    </a>
                    <a ng-click="sort('status','asc')" ng-if="filterData.sort == 'desc'">
                        <i class="fa fa-sort-alpha-asc"></i>
                    </a> -->
                </th>
            </tr>
        </thead>
        <tbody>
        <tr 
            dir-paginate="item in data.orders.data | itemsPerPage: 30" 
            total-items="data.orders.total" 
            current-page="data.orders.current_page">
            <td class="clickable-row">
                <label class="option block mn" ng-if="item.status == 0 || item.status == null">
                    <input type="checkbox" ng-click="addSelectedItem(item.id)" ng-checked="selectedItem.indexOf(item.id) > -1 || master" id="checkboxDefault-{{item.id}}">
                    <span class="checkbox mn"></span>
                </label>
            </td>
            
            <td class="clickable-row" ng-click="getOrderDetails(item)">
                {{ item.customer.customer_name }}
                <p ng-if="item.sender">{{ item.sender }}</p>
                <p ng-if="item.uber_order_map">Uber</p>
                <p ng-if="item.doordash_order_map">Doordash</p>
                <p ng-if="item.delivery_mail_order_map">Delivery.com</p>
            </td>
            <td class="clickable-row" ng-click="getOrderDetails(item)">
                <div class="avatar-container">
                    <div class="avatar-img">
                        {{ item.location.name.split(' ')[0][0] }}{{ item.location.name.split(' ')[1][0] }}
                    </div>
                    <div class="avatar-detail">
                        <strong style="font-weight:bold">{{ item.location.name }}</strong>
                        {{ item.location.email }}
                    </div>
                </div>
            </td>
            <td class="clickable-row" ng-click="getOrderDetails(item)">
                {{item.unique}}
            </td>
            <td class="clickable-row" ng-click="getOrderDetails(item)">
                {{ item.created_at | amDateFormat:'MM/DD/YYYY' }}
            </td>
            <td class="clickable-row" ng-click="getOrderDetails(item)">
                <span ng-if="item.scheduled_time">{{ item.scheduled_time | amDateFormat:'MM/DD/YYYY' }}</span>
                <span ng-if="!item.scheduled_time">Flexible Date</span>
            </td>
            <td class="clickable-row" ng-click="getOrderDetails(item)">
                <span ng-if="item.completed_at">{{ item.completed_at | amDateFormat:'MM/DD/YYYY H:mm A' }}</span>
                <span ng-if="!item.completed_at">-</span>
            </td>
            <td class="clickable-row mw200" ng-click="getOrderDetails(item)">{{ item.piece  }}</td>
            <td class="clickable-row mw200" ng-click="getOrderDetails(item)">{{ item.name | cut:true:40:' ...' }}</td>
            <td class="clickable-row" ng-click="getOrderDetails(item)">
                {{ item.worker ? item.worker.full_name : '-' }}
            </td>							
            <td class="clickable-row" ng-click="getOrderDetails(item)">
                <span ng-if="item.status" ng-style="{'color': item.status.color }">{{ item.status.name }}</span>	
                <span ng-if="!item.status">Created</span>
            </td>
        </tr>
        </tbody>
    </table>
    <dir-pagination-controls 
        boundary-links="true" 
        on-page-change="getPage(newPageNumber)" 
        template-url="dirPagination.tpl.html"
        class="pagination-lg pagination pull-right pr10">
    </dir-pagination-controls>
    <small class="text-center pr10 total-record">Total Record : {{ data.orders.total }}</small>

</div>

<div class="text-center mt50" ng-if="data.orders.data.length == 0">
    <img src="img/empty_page_orange.svg" alt="" width="400px">
    <br>
    <h3 style="font-size: 48px;font-weight: 800;">No orders yet</h3>
</div>
